 (function () {
    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  
  })();

$(".categories-filter .header__icon--menu").click(function(){
  $(".categories-filter .menu-drawer-container").addClass("menu-opening");
});

$( '.press .multicolumn-card__info a' ).attr( 'target', '_blank' );

$(document).ready(function() {
      $('.blog_items_qa .blog-qa__item:nth-child(1) .blog-qa__title').addClass('active');
      $('.blog_items_qa .blog-qa__item:nth-child(1) .blog-qa__body').slideDown();
      $('.blog-qa__title').on('click', function() {
          if($(this).hasClass('active')) {
          $(this).siblings('.blog-qa__body').slideUp();
          $(this).removeClass('active');
          }
          else {
          $('.blog-qa__body').slideUp();
          $('.blog-qa__title').removeClass('active');
          $(this).siblings('.blog-qa__body').slideToggle();
          $(this).toggleClass('active');
          }
      });
  });  